export default {
  name: 'GoogleReviews',
  data () {
    return {
      callingAPI: false,
      place: {
        "name": "Dr Ryan SAAD - Chirurgie Orale & Implantologie",
        "vicinity": "Clinique Sainte-Geneviève, 29 Rue Sarrette, Paris",
        "reviews": [
          {
            "author_name": "Julien Fenniche",
            "rating": 5,
            "time": "il y a 11 mois",
            "text": "Le Docteur Saad m'a opéré pour des implants dentaires. Excellent Docteur, chirurgie sans douleur et résultat parfait. Sa clinique est très bien, j'ai été ravi de la prise en charge. Encore merci Docteur et bravo !",
            "visit_day": "Visité en mai 2019"
          },
          {
            "author_name": "Diarra Ngom",
            "rating": 5,
            "time": "il y a 10 mois",
            "text": "Je recommande vivement le Docteur Saad qui est très à l'écoute et consciencieux. Je suis très satisfaite des soins reçus et n'ai eu aucune douleur post-intervention. J'ai constaté des améliorations nettes et immédiates suite au traitement parodontal.",
            "visit_day": "Visité en juin 2019"
          },
          {
            "author_name": "Rémi Schmadel",
            "rating": 5,
            "time": "il y a 10 mois",
            "text": "Un grand professionnalisme et une écoute hors paire ! Le Dr SAAD a su me retirer mes 4 dents de sagesse d’une main de maître et avec une très grande pédagogie. Le suivi post opératoire a lui aussi été d’une très grande qualité et je n’ai aujourd’hui plus aucune séquelle ou autre liée à son intervention. Encore merci , on manque de médecin comme vous !",
            "visit_day": "Visité en juin 2019"
          },
          {
            "author_name": "blandine fleuret",
            "rating": 5,
            "time": "il y a un an",
            "text": "J'étais un peu perdue par une multitude d'avis concernant ma gencive quand je suis allée le voir, mais il prend le temps de bien tout expliquer. Et suite au traitement la gencive à plutôt bien prise même si ce n'est pas exactement comme avant le déchaussement"
          },
          {
            "author_name": "Andrea FREIRA",
            "rating": 5,
            "time": "il y a un an",
            "text": "Spécialiste très bien équipé, avec une équipe très sympathique qui permet de se sentir à l'aise. Par contre, attention à avoir une bonne mutuelle car les tarifs en implantologie peuvent être en grande partie à votre charge !"
          },
          {
            "author_name": "Desarthe Monique",
            "rating": 5,
            "time": "il y a un an",
            "text": "Je recommande très chaleureusement le DR SAAD, calme, rassurant, ultra professionnel, joignable directement, très disponible. J'ai subi une avulsion de plusieurs dents avec comblement pour renforcer la gencive, puis  pose d'une prothèse totale amovible du maxillaire supérieur. aucune douleur pendant et les jours suivants l'intervention. avec des conseils post-opératoires très utiles et efficaces. Ma nouvelle prothèse est très confortable, je parle normalement, et l'effet des dents est très naturel, même mon entourage ne s'en est pas rendu compte ! Encore un très grand merci au Dr SAAD, que je conseillerai avec plaisir à tout mon entourage."
          },
          {
            "author_name": "Ichrak Ben Taarit",
            "rating": 5,
            "time": "il y a 6 mois",
            "text": "Un médecin qui honore véritablement le serment d’hypocrate. Un très bon dentiste.",
            "visit_day": "Visité en novembre 2019"
          },
          {
            "author_name": "Manon Mayeur",
            "rating": 5,
            "time": "il y a un an",
            "text": "Je recommande vivement le docteur Saad après une operation des 4 dents de sagesse. Rassurant et à l'écoute il a fait un travail remarquable dans la bonne humeur."
          },
          {
            "author_name": "Hanya HASSACI",
            "rating": 5,
            "time": "il y a 11 mois",
            "text": "Très anxieuse avant une extraction de dents de sagesse, le Dr SAAD a été extrêmement patient et rassurant. Aucune douleur pendant ou après l'opération alors, si besoin est, j'y retournerai sans hésiter."
          },
          {
            "author_name": "Marc Fert",
            "rating": 5,
            "time": "il y a un an",
            "text": "Nous avons été adressé chez ce spécialiste par notre dentiste pour ma jeune fille. Le Dr SAAD a été une personne très rassurante durant toute l'intervention, je recommande fortement"
          },
          {
            "author_name": "Sharon Menardo",
            "rating": 5,
            "time": "il y a un an",
            "text": "J'avais très peur avant l'opération des dents de sagesse mais le Docteur Saad a su me mettre en confiance et je n'ai eu aucune douleur ni pendant ni après l'operation et je n'ai pas gonflée ! Très professionnel, il connaît très bien son métier. Je recommande vivement."
          },
          {
            "author_name": "Hugo Koessler",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Un des meilleurs chirurgien que j'ai pu croiser. D'abord, la structure est très propre,  sereine et accueillante. L' équipe est sympathique des secrétaires à l'assistante ainsi que les étudiants en dentaire qui viennent observer certaines interventions. Enfin, le praticien se montre disponible et joignable assez rapidement. Et le résultat de l'intervention est parfait."
          },
          {
            "author_name": "Jean Semey",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Bonjour, je vous partage ici mon expérience avec ce docteur. J'ai eu une opération il y a 1 mois. Le docteur Saad m'a opéré dans sa clinique, il vous reçoit avec sérieux, et il est très compétent et d'une grande gentillesse, mais surtout très humain. Au final, durant la chirurgie, zéro douleur, et un résultat final super à la hauteur de mes espérances. Je recommande à 100%"
          },
          {
            "author_name": "Jacques NDONGA",
            "rating": 5,
            "time": "il y a un an",
            "text": "Greffe au niveau du sinnus sans grande douleur, on verra comme se passe la suite pour l'implant"
          },
          {
            "author_name": "M'hamed HASSANE",
            "rating": 5,
            "time": "il y a un an",
            "text": "Extraction de dents de sagesses dans de super conditions propre, rapide, bonne prise en charge. Dr Saad était toujours disponible avant et après l'extraction. Je recommande."
          },
          {
            "author_name": "Megane Boudier",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Praticien très compétent et prend le temps d'expliquer le traitement. Ce qui est rassurant lorsqu'on appréhende beaucoup les choses. Greffe osseuse dans le sinus qui s'est déroulée sans encombre."
          },
          {
            "author_name": "Bochra Boubaker",
            "rating": 5,
            "time": "il y a un an",
            "text": "Exttaction de dents de sagesses dans de super conditions propre, rapide, bonne prise en charge. Je recommande."
          },
          {
            "author_name": "Sarah Mez",
            "rating": 5,
            "time": "il y a 2 mois",
            "text": "Je suis très contente car j’ai eu une très forte et grosse infections sur mes dents 4 dents de sagesse c’était une douleur insupportable et jetait au plus mal MR SAAD ma très bien accompagné ma bien conseillé ma trouver un traitement qui dès le lendemain c’est totalement arrêté au niveau de la douleur j’ai fait 4 dentiste avant lui qui sont juste nul et pas du tout professionnel et très cher mais Mr SAAD a était tellement professionnel propre dans son travaille à pris tout le temps de m’expliquer avec douceur il m’a retirer du coup les 4 dents de sagesse et sa a bien cicatrisé au bout de 2 semaines je suis juste super contente d’avoir eu un bon traitement et merci pour son honnêteté  et son professionnalisme JE RECOMMANDE MR SAAD ! Merci encore de m’avoir soigner mes dents",
            "visit_day": "Visité en février"
          },
          {
            "author_name": "abderrahim masbah",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Anxieux avant de me faire retirer les 4 dents de sagesses, le Dr Saad m'a mis en confiance en faisant preuve d'un grand professionnalisme. Rapide et efficace, aucune douleur. Je recommande vivement !"
          },
          {
            "author_name": "Eveline Ngo-Le Gall",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Praticien sympa et qui sait mettre en confiance. Et la structure hospitalière rassure vraiment"
          },
          {
            "author_name": "Jerome HASS",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Très humain et très pro. Praticien recommandé par mon dentiste pour une pose d'implant et à juste titre."
          },
          {
            "author_name": "MARIAM Sargsyan",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Le top du top!! Un grand merci au Dr Saad pour son professionnalisme . Je recommande vivement!"
          },
          {
            "author_name": "RaPh Blind",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Chirurgien à l'écoute, explications très claires, intervention rapide sans aucune complication. Je recommande sans hésiter."
          },
          {
            "author_name": "Sarah Charpy",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Calme, rassurant, souriant et ultra professionnel. Impeccable."
          },
          {
            "author_name": "Amine Jafari",
            "rating": 5,
            "time": "il y a 2 ans",
            "text": "Très satisfait de ma prise en charge et notamment de mon suivi"
          },
          {
            "author_name": "Rachel Jones",
            "rating": 5,
            "time": "il y a 9 mois",
            "text": "",
            "visit_day": "Visité en août 2019"
          },
          {
            "author_name": "Noura Hamila",
            "rating": 5,
            "time": "il y a 5 mois",
            "text": "",
            "visit_day": "Visité en décembre 2019"
          }
        ]
      },
      el: null
    }
  },
  mounted: function() {
    if (this.callingAPI) {
      // Calling GOOGLE API to DYNAMICALLY retrieve Reviews
      this.loadURL("https://maps.googleapis.com/maps/api/js?&key=AIzaSyCe1exctmeJjIb4guyT6newSpyJ7kA3aLc&libraries=places",
        this.callBack
      )
    }
  },
  methods: {
    loadURL(url, callback) {
      var id = "script-tag-temp"
      var scriptTag = document.createElement("script")
      scriptTag.id = id
      document.body.appendChild(scriptTag)
      if(callback !== undefined)
      {
        scriptTag.onload = callback
      }
      scriptTag.src = url
    },
    dispose() {
      var id = "script-tag-temp"
      var scriptTag = document.getElementById(id)
      scriptTag.parentNode.removeChild(scriptTag)
    },
    sortByDate(list) {
      list.sort(function(a, b)
      {
        var keyA = new Date(a.time),
        keyB = new Date(b.time)
        // Compare the 2 dates
        if(keyA < keyB) return 1
        if(keyA > keyB) return -1
        return 0
      })
      return list
    },
    countryAddress(data) {
      return data[4].long_name + (data[5] === undefined ? "" : ", " + data[5].long_name)
    },
    convertTime(Unix_Timestamp) {
      var date = new Date(Unix_Timestamp * 1000)
      var months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
      return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear()
    },
    callBack() {
      var el = document.getElementById("googleReviews")
      var tempDiv = document.createElement("div")
      tempDiv.id = "map-temp"
      el.appendChild(tempDiv)
      var placeID = "ChIJOR_Y369x5kcRbHZtyjQgJKY"
      var service = new google.maps.places.PlacesService(tempDiv)
      var thisDup = this
      service.getDetails({placeId: placeID}, function(place, status)
      {
        //remove temporary placeholder div
        el.removeChild(tempDiv)

        if(status === "OK")
        {
          thisDup.place = place
        } else
        {
          el.innerHTML = "<div class='loader'>" + status + "</div>"
        }
      })
    }
  },
  computed: {
  },
  watch: {
  }
}



// WEBPACK FOOTER //
// ./src/views/global/googleReviews/googleReviews.component.js